module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0066.png.27274036.jpg";